/** @format */

import styled from 'styled-components';

export const StyledGeocoder = styled.div`
  .mapboxgl-ctrl-geocoder--input:disabled {
    opacity: 1;
    -webkit-text-fill-color: inherit;
    color: inherit;
    background-color: inherit;
    cursor: pointer;
  }
`;
